export const mockLineData = [
    {
      id: "patients",
      color: "#3182CE", // Example color for patients data
      data: [
        { x: "January", y: 1200 },
        { x: "February", y: 1100 },
        { x: "March", y: 1250 },
        { x: "April", y: 1300 },
        { x: "May", y: 1350 },
        { x: "June", y: 1400 },
        { x: "July", y: 1450 },
        { x: "August", y: 1500 },
        { x: "September", y: 1550 },
        { x: "October", y: 1600 },
        { x: "November", y: 1650 },
        { x: "December", y: 1700 },
      ],
    },
    {
      id: "deaths",
      color: "#EF4444", // Example color for deaths data
      data: [
        { x: "January", y: 50 },
        { x: "February", y: 40 },
        { x: "March", y: 45 },
        { x: "April", y: 55 },
        { x: "May", y: 60 },
        { x: "June", y: 65 },
        { x: "July", y: 70 },
        { x: "August", y: 75 },
        { x: "September", y: 80 },
        { x: "October", y: 85 },
        { x: "November", y: 90 },
        { x: "December", y: 95 },
      ],
    },
    {
      id: "surgeries",
      color: "#6B7280", // Example color for surgeries data
      data: [
        { x: "January", y: 100 },
        { x: "February", y: 90 },
        { x: "March", y: 110 },
        { x: "April", y: 105 },
        { x: "May", y: 115 },
        { x: "June", y: 120 },
        { x: "July", y: 125 },
        { x: "August", y: 130 },
        { x: "September", y: 135 },
        { x: "October", y: 140 },
        { x: "November", y: 145 },
        { x: "December", y: 150 },
      ],
    },
    {
      id: "admissions",
      color: "#34D399", // Example color for admissions data
      data: [
        { x: "January", y: 200 },
        { x: "February", y: 180 },
        { x: "March", y: 210 },
        { x: "April", y: 205 },
        { x: "May", y: 220 },
        { x: "June", y: 230 },
        { x: "July", y: 240 },
        { x: "August", y: 250 },
        { x: "September", y: 260 },
        { x: "October", y: 270 },
        { x: "November", y: 280 },
        { x: "December", y: 290 },
      ],
    },
    {
      id: "discharges",
      color: "#4ADE80", // Example color for discharges data
      data: [
        { x: "January", y: 180 },
        { x: "February", y: 170 },
        { x: "March", y: 190 },
        { x: "April", y: 185 },
        { x: "May", y: 200 },
        { x: "June", y: 210 },
        { x: "July", y: 220 },
        { x: "August", y: 230 },
        { x: "September", y: 240 },
        { x: "October", y: 250 },
        { x: "November", y: 260 },
        { x: "December", y: 270 },
      ],
    },
  ];
  